import { InjectionToken } from '@angular/core';

/**
 * LocalPagePathConstants
 */

const localPagePathsConstants = {
  AKRON: {
    city: 'Akron',
    state: 'Ohio',
    redirectUrl: '/locations/ohio/akron-trash-pickup-and-recycling',
  },
  COLUMBUS: {
    city: 'Columbus',
    state: 'Ohio',
    redirectUrl: '/locations/ohio/columbus-trash-pickup-and-recycling',
  },
  ALLENTOWN: {
    city: 'Allentown',
    state: 'Pennsylvania',
    redirectUrl: '/locations/pennsylvania/allentown-trash-pickup-and-recycling',
  },
  CENTRAL_NEW_JERSEY: {
    city: 'Central New Jersey',
    state: 'New Jersey',
    redirectUrl:
      '/locations/new-jersey/central-new-jersey-trash-pickup-and-recycling',
  },
  DENVER: {
    city: 'Denver',
    state: 'Colorado',
    redirectUrl: '/locations/colorado/denver-trash-pickup-and-recycling',
  },
  FALL_RIVER: {
    city: 'Fall River',
    state: 'Massachusetts',
    redirectUrl:
      '/locations/massachusetts/fall-river-trash-pickup-and-recycling',
  },
  GRAND_RAPIDS: {
    city: 'Grand Rapids',
    state: 'Michigan',
    redirectUrl: '/locations/michigan/grand-rapids-trash-pickup-and-recycling',
  },
  MINNEAPOLIS: {
    city: 'Minneapolis',
    state: 'Minnesota',
    redirectUrl: '/locations/minnesota/minneapolis-trash-pickup-and-recycling',
  },
  NORTHERN_VIRGINIA: {
    city: 'Northern Virginia',
    state: 'Virginia',
    redirectUrl:
      '/locations/virginia/northern-virginia-trash-pickup-and-recycling',
  },
  PHILADELPHIA: {
    city: 'Philadelphia',
    state: 'Pennsylvania',
    redirectUrl:
      '/locations/pennsylvania/philadelphia-trash-pickup-and-recycling',
  },
};

export type LocalPagePathConstants = typeof localPagePathsConstants;

export const localPagePathsConstantsToken =
  new InjectionToken<LocalPagePathConstants>('localPagePathsConstantsToken');

export default localPagePathsConstants;
